export default "/_next/static/images/07941b68bc29dd97e00cd80a8328f0fb.jpg";